import { GatsbyBrowser } from 'gatsby'

const gatsbyBrowser: GatsbyBrowser = {}

module.exports = gatsbyBrowser
